import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { UpdateButton } from '../../../search/FiltersModal/Filters.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customThemeOverrides = (ancestorTheme: any): any => ({
    ...ancestorTheme,
    input: {
        ...ancestorTheme.input,
        borderColor: '#d1d0cf'
    }
});

type Props = {
    hasExtraPaddingTop?: boolean;
};
export const SearchInitationWrapper = styled.div<Props>(
    ({ theme: { mq, spacing }, hasExtraPaddingTop }) => {
        return css`
            position: relative;
            z-index: 3;
            width: 100%;
            margin: 0 auto;
            display: flex;
            padding-top: ${hasExtraPaddingTop ? spacing['24px'] : 0};

            ${mq.large} {
                display: flex;
                align-items: center;
            }
        `;
    }
);

export const StyledButtonWrapperMobile = styled('div')(
    ({ theme: { colors, spacing, input } }) => css`
        background-color: ${colors['white']};
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid ${input.borderColor};
        border-right: 1px solid ${input.borderColor};
        border-bottom: 1px solid ${input.borderColor};
        height: 3.35rem;
        padding-right: ${spacing['8px']};
        border-top-right-radius: ${spacing['4px']};
        border-bottom-right-radius: ${spacing['4px']};
    `
);

export const StyledButtonWrapper = styled('div')(
    ({ theme: { colors, input, spacing } }) => css`
        background-color: ${colors['white']};
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid ${input.borderColorSearch};
        border-right: 1px solid ${input.borderColorSearch};
        border-bottom: 1px solid ${input.borderColorSearch};
        height: 4.875rem;
        padding-right: ${spacing['16px']};
        border-top-right-radius: ${spacing['4px']};
        border-bottom-right-radius: ${spacing['4px']};
    `
);

export const StyledButton = styled(UpdateButton)(
    ({ theme: { spacing } }) => css`
        min-width: 8.75rem;
        margin-left: ${spacing['8px']};
        font-size: ${spacing['16px']};
    `
);

export const StyledButtonMobile = styled(UpdateButton)(
    ({ theme: { spacing } }) => css`
        min-width: 4.75rem;
        margin-left: ${spacing['8px']};
        font-size: ${spacing['16px']};
    `
);

const StyledMultiColumnDropdown = styled.div(
    () => css`
        display: block;
        flex-grow: 1;
    `
);

export const SearchRadiusWrapper = styled(StyledMultiColumnDropdown)(
    () => css`
        flex-basis: 7%;
    `
);

export const BedroomsWrapper = styled(StyledMultiColumnDropdown)(
    () => css`
        flex-basis: 5%;
    `
);

export const TravelTimeWrapper = styled(StyledMultiColumnDropdown)(
    () => css`
        flex-basis: 15%;
    `
);

export const PriceRangeMultiColumnDropdownWrapper = styled(
    StyledMultiColumnDropdown
)(
    () => css`
        flex-basis: 10%;
    `
);
export const PropertyTypeWrapper = styled(StyledMultiColumnDropdown)(
    () => css`
        flex-basis: 13%;
    `
);

export const StyledDividerInner = styled('span')(
    ({ theme: { input } }) => css`
        position: absolute;
        top: 0;
        height: 1.5rem;
        width: 1px;
        background-color: ${input.borderColorSearch};
    `
);

export const StyledDivider = styled('div')(
    ({ theme: { input } }) => css`
        width: 2px;
        height: 78px;
        background-color: white;
        position: relative;
        border-top: 1px solid ${input.borderColor};
        border-bottom: 1px solid ${input.borderColor};
    `
);

export const LocationWrapper = styled.div(
    () => css`
        width: 22rem;
    `
);

export const HousePricesLocationWrapper = styled.div(
    ({ theme: { mq } }) => css`
        width: 100%;

        ${mq.medium} {
            width: 38%;
        }
    `
);
